module.exports = __webpack_public_path__ + "img/receipt21.ad526542.png";